var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flat-card"},[(_vm.title?.length > 0)?[_c('h6',{staticClass:"flat-card__title"},[_vm._v(" "+_vm._s(_vm.title)+" ")])]:_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }